<!-- /**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */ -->
<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <patient-information
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <Patient-consultation-info
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
    </v-row>
    <br />
    <v-row class="mt-2 mb-2">
      <v-expansion-panels v-model="panelSV" >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Somatometría</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col cols="12" md="12" sm="12">
              <patient-somatometry
                :model="model"
                :isViewDetailsForm="isViewDetailsForm"
                :suimFlag="suimFlag"
              />
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <patient-antecedents
                :model="model"
                :isViewDetailsForm="isViewDetailsForm"
              />
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-divider></v-divider>
      <div class="separator20-50"></div>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <DiagnosticHypothesisComponent
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <PatientCIE10Component
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
          :isUpdate="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientSomatometry from "@/app/components/common/patient/PatientSomatometry.vue";
import PatientCIE10Component from "@/app/components/common/patient/PatientCIE10Component.vue";
import DiagnosticHypothesisComponent from "@/app/components/psychology/components/DiagnosticHypothesisComponent.vue";
import PatientAntecedents from "@/app/components/common/patient/PatientAntecedents.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
export default {
  props: {
    model: Object,
    idMedicalPractice: String,
    isViewDetailsForm: Boolean,
  },
  components: {
    PatientInformation,
    PatientSomatometry,
    PatientCIE10Component,
    DiagnosticHypothesisComponent,
    PatientAntecedents,
    PatientConsultationInfo,
  },
  data() {
    return {
      dialogPDF: false,
      panelSV: 0,
      suimFlag: 1,
    };
  },
  mounted() {
    this.model.idHumanResource = this.$utilFront.getIdHumanResource();
  },
  methods: {},
};
</script>
